import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSub } from '@core/event-bus';
import { TableState } from '@core/table';

import { useBranchPartnersTableColumns } from './';
import { BranchPartnersTableContext } from '../../contexts';

export const useBranchPartnersTable = () => {
  const { fetch, mergeState } = useContext(BranchPartnersTableContext);

  const location = useLocation<{ branchesTable?: { mergeState?: Partial<TableState> } }>();
  const columns = useBranchPartnersTableColumns();

  useSub(['@branch-partners/create/succeed', '@branch-partners/update/succeed', '@branch-partners/remove/succeed'], () => {
    fetch();
  });

  useEffect(() => {
    if (location.state?.branchesTable?.mergeState) {
      mergeState(location.state.branchesTable.mergeState);
    }
  }, [location.state?.branchesTable?.mergeState, mergeState]);

  return { columns };
};
